module.exports = __webpack_public_path__ + "assets/images/movie-clapper-open-small.png";